import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _class2, _descriptor, _UserStatusService_brand;
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import Service, { service } from "@ember/service";
import { ajax } from "discourse/lib/ajax";
import DoNotDisturb from "discourse/lib/do-not-disturb";
import { disableImplicitInjections } from "discourse/lib/implicit-injections";
let UserStatusService = disableImplicitInjections(_class = (_class2 = (_UserStatusService_brand = /*#__PURE__*/new WeakSet(), class UserStatusService extends Service {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _UserStatusService_brand);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
  }
  async set(status, pauseNotifications) {
    await ajax({
      url: "/user-status.json",
      type: "PUT",
      data: status
    });
    this.currentUser.set("status", status);
    if (pauseNotifications) {
      _assertClassBrand(_UserStatusService_brand, this, _enterDoNotDisturb).call(this, status.ends_at);
    } else {
      _assertClassBrand(_UserStatusService_brand, this, _leaveDoNotDisturb).call(this);
    }
  }
  async clear() {
    await ajax({
      url: "/user-status.json",
      type: "DELETE"
    });
    this.currentUser.set("status", null);
    _assertClassBrand(_UserStatusService_brand, this, _leaveDoNotDisturb).call(this);
  }
}), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class;
function _enterDoNotDisturb(endsAt) {
  const duration = _assertClassBrand(_UserStatusService_brand, this, _duration).call(this, endsAt ?? DoNotDisturb.forever);
  this.currentUser.enterDoNotDisturbFor(duration);
}
function _leaveDoNotDisturb() {
  if (!this.currentUser.isInDoNotDisturb()) {
    return;
  }
  this.currentUser.leaveDoNotDisturb();
}
function _duration(endsAt) {
  return moment.utc(endsAt).diff(moment.utc(), "minutes");
}
export { UserStatusService as default };